const Underline = () => {

    return (
        <div className='h-0 mx-2 my-2 border border-white border-b-0' />
    )
}

export default Underline;
